type StepLike = {
  riskReductionMeasure?: { type?: string; name?: string; description?: string | null } | null
  riskOutInjury?: string | null
  riskOutFrequency?: string | null
  riskOutAvoidance?: string | null
  riskOutLikelihood?: string | null
}

/** A step is "complete" when it has a risk reduction measure and all risk-out fields filled. */
export function isCompleteRiskAssessmentStep(step: StepLike): boolean {
  const hasMeasure = step.riskReductionMeasure != null
  return (
    hasMeasure &&
    (step.riskOutInjury ?? '').trim() !== '' &&
    (step.riskOutFrequency ?? '').trim() !== '' &&
    (step.riskOutAvoidance ?? '').trim() !== '' &&
    (step.riskOutLikelihood ?? '').trim() !== ''
  )
}

export function hasAtLeastOneCompleteStep(steps: StepLike[]): boolean {
  return steps.some((step) => isCompleteRiskAssessmentStep(step))
}
